export default __webpack_public_path__ + "static/media/grobG115.7c671ac7.png";